import * as types from 'modules/hardwares/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isLoading = (): boolean => true;

const isEnding = (): boolean => false;

export default createReducer<boolean>(initialState, {
  [types.FETCH_HARDWARES_REQUEST]: isLoading,
  [types.FETCH_HARDWARES_SUCCESS]: isEnding,
  [types.FETCH_HARDWARES_FAILURE]: isEnding,
  [types.FETCH_UNASSIGNED_HARDWARES_REQUEST]: isLoading,
  [types.FETCH_UNASSIGNED_HARDWARES_SUCCESS]: isEnding,
  [types.FETCH_UNASSIGNED_HARDWARES_FAILURE]: isEnding,
  [types.PATCH_STATUS_HARDWARE_REQUEST]: isLoading,
  [types.PATCH_STATUS_HARDWARE_SUCCESS]: isEnding,
  [types.PATCH_STATUS_HARDWARE_FAILURE]: isEnding,
});
